import { AppFrame } from "@onlinetools/ui";

export function Terms() {
  return (
    <AppFrame title="Terms of Service">
      <title>Terms of Service - Any Tool Online</title>
      <meta
        content="Terms of Service for Any Tool Online - free, stateless web utilities."
        name="description"
      />
      <article className="prose-page">
        <p className="eyebrow">Last updated May 2026</p>

        <section>
          <h2>The service</h2>
          <p>
            Any Tool Online provides free, stateless web utilities - QR code generation, PDF
            merging, and PDF conversion. The tools process your input and return a result. Nothing
            is stored. No account is required.
          </p>
        </section>

        <section>
          <h2>Your use</h2>
          <p>
            You may use these tools for any lawful purpose. You agree not to submit content that
            is illegal, harmful, or that you do not have the right to process. You are responsible
            for the content you upload and what you do with the output.
          </p>
          <p>
            Automated or scripted use that disrupts the service for others is not permitted.
            Rate limits are enforced per IP address.
          </p>
        </section>

        <section>
          <h2>No warranties</h2>
          <p>
            The service is provided &ldquo;as is&rdquo; without warranties of any kind. We do not
            guarantee that output files will be correct, complete, or fit for any particular
            purpose. Always verify important output independently before relying on it.
          </p>
        </section>

        <section>
          <h2>Limitation of liability</h2>
          <p>
            To the maximum extent permitted by law, Any Tool Online and its operators are not
            liable for any loss or damage arising from your use of the service, including loss of
            data or reliance on output produced by the tools.
          </p>
        </section>

        <section>
          <h2>Changes to the service</h2>
          <p>
            We may modify, suspend, or discontinue any part of the service at any time without
            notice. We may also update these terms; the date at the top of this page reflects the
            most recent revision.
          </p>
        </section>

      </article>
    </AppFrame>
  );
}
